
import { db } from "../firebase";

import {
  collection,
  addDoc,
  serverTimestamp,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

export const saveEnquiry = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, "enquiries"), {
      ...formData,
      status: "New",
      createdAt: serverTimestamp(),
    });

    return {
      success: true,
      id: docRef.id,
    };
 } catch (error) {
  console.error("Error saving enquiry:", error);
  console.error("Error Code:", error.code);
  console.error("Error Message:", error.message);

  return {
    success: false,
    error,
  };
}
};
export const getEnquiries = async () => {
  try {
    const q = query(
      collection(db, "enquiries"),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const enquiries = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return enquiries;
  } catch (error) {
    console.error("Error fetching enquiries:", error);
    return [];
  }
};